window.isFrenzyEventApiCall = true;
let all_product = '';
function frenzyQuickAdd(this_click){}
function frenzyQuickRemove(that){}

window.frenzyCartCallBack = function(){
   cart_count_update();
}
const cart_count_update = async () => {
   const response = await fetch(Shopify.routes.root + "cart.js", {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const data = await response.json();
    var cart_count = data?.item_count;
  if(document.querySelector('[data-cart-amount]')){
    document.querySelector('[data-cart-amount]').innerHTML = cart_count;
  }

  new App.Cart().get()

  
}
window.FrenzyProductGridChangeCallBack = function(html,data){

  var product_images = data?.org_image_url.split(' ');
  html.querySelector('.frenzy_img_second').setAttribute('src', product_images[product_images.length - 1]);
  
  if(data?.smf_eco && data?.smf_eco[0] == '1' || data?.smf_saxtoc && data?.smf_saxtoc[0] == '1'){
    html.querySelector('.product__labels').classList.add('is-active');
  }
  if(data?.org_collection_metafield && data?.org_collection_metafield != ''){
    let discount_label = JSON.parse(data?.org_collection_metafield);
    discount_label = discount_label?.["discount@discount"];
    html.querySelector('.frenzy_discount_label') ? html.querySelector('.frenzy_discount_label').innerHTML = discount_label : '' ;
  }

    if(data?.smf_badges && data.smf_badges.length>0){

    let badge_block = document.createElement("div");
    badge_block.classList.add("product__badge-block");
    
    if (html.querySelector('.product__badges')) {
      html.querySelector('.product__badges').appendChild(badge_block);
    } 

    data.smf_badges.forEach((smf_badge, index) => {

      let badge_block_item = document.createElement("div");
      badge_block_item.classList.add("product__badge", "frenzy_product__badge--text");
      badge_block_item.innerHTML = smf_badge;
      
      badge_block.appendChild(badge_block_item);
    });
  }
  
 frenzySwatch(data?.org_prod_url,data?.sku,html);  
}
const frenzySwatch = async(handle,sku,html) =>{
  
  let frenzy_product_grid_swatch = window.location.origin+Shopify.routes.root+"products/" + handle + "?view=frenzy_product_grid_swatch";
  if(handle.includes('variant')){
    frenzy_product_grid_swatch = window.location.origin+Shopify.routes.root+"products/" + handle + "&view=frenzy_product_grid_swatch";
  }else{
    frenzy_product_grid_swatch = window.location.origin+Shopify.routes.root+"products/" + handle + "?view=frenzy_product_grid_swatch";
  }
   const response = await fetch(frenzy_product_grid_swatch, {
      method: "GET",
  });
  const result = await response.text();
  if(result){
    const new_HTML = new DOMParser().parseFromString(result, "text/html");
    document.querySelectorAll('.frenzy_product_item[data-id="'+sku+'"]').forEach(function(this_click){
      this_click.querySelector('.frezny_swatch').innerHTML = '<ul class="product__types">'+new_HTML.querySelector('.product__types').innerHTML+'</ul>';;
    })
  }  
}
window.frenzyFilterClickCallBack = function(){
   if(document.querySelector('.frenzy_collections_page')){
      var targetElement = document.querySelector('.frenzy_collections_page');
          var targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - 230;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth' // Smooth scrolling
          });
    }else{
          var targetElement = document.querySelector('.frenzy_search_page');
          setTimeout(function() {
            var targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - 230;
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth' // Smooth scrolling
            });
          },10);
    }
}

document.addEventListener('rebuy:cart.change', function(event) {
  cart_count_update();
  frenzyAsyncItems();
});